import vx from 'vx'
import Router from 'vue-router'
import sign from "@/views/sign/sign"
import agreement from "@/views/Agreement/agreement"
import empty from "@/views/empty/empty"
import bind from "@/views/bind/bind"
import desc from "@/views/desc/desc"
import descScan from "@/views/descScan/descScan"
import system from "@/views/system/system"
vx.use(Router);


const router = new Router({
  mode: 'history',
  base: '/cnewec/',
  routes: [
    {
      path: '/',
      name: 'system',
      component: system
    },
    {
      path: '/bind',
      name: 'bind',
      component: bind
    },
    {
      path: '/descScan',
      name: 'descScan',
      component: descScan
    },
    {
      path: '/desc',
      name: 'desc',
      component: desc
    }
  ]
});
//维护登陆
// const canNotLogin = ['/bestGoodIndex', '/', '/loginAndRegister/login', '/loginAndRegister/register',
//   '/loginAndRegister/forgetPassword', '/loginAndRegister/setPassword', '/RealNameCertification/identityInfoEntry',
//   '/RealNameCertification/bindingBankCard', '/RealNameCertification/setPsd', '/RealNameCertification/openAccSuccess'];
// router.beforeEach((to, from, next) => {
//   if (sessionStorage.getItem('isLogin')==='login') {
//     next()
//   } else if (canNotLogin.indexOf(to.fullPath) > -1) {
//     next()
//   }else {
//     next('/loginAndRegister/login')
//   }
// });
// router.beforeEach((to, from, next) => {
// })
// router.beforeEach((to, from, next) => {
//   if (!window.initUrl) {
//     window.initUrl = location.href.split('#')[0]
//   }
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js